export default {
  namespaced: true,

  state: {
    savingProjectError: null
  },

  getters: {
    getSavingError: (state) => state.savingProjectError
  },

  mutations: {
    setSavingProjectError (state, error) {
      state.savingProjectError = error;
    }
  },

  actions: {
    setSavingProjectError ({ commit }, error) {
      commit('setSavingProjectError', error);
    }
  },
};
